/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupmovedown2Inputs */

const en_signupmovedown2 = /** @type {(inputs: Signupmovedown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move down`)
};

const de_signupmovedown2 = /** @type {(inputs: Signupmovedown2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach unten`)
};

/**
* | output |
* | --- |
* | "Move down" |
*
* @param {Signupmovedown2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupmovedown2 = /** @type {((inputs?: Signupmovedown2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupmovedown2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupmovedown2(inputs)
	return de_signupmovedown2(inputs)
});
export { signupmovedown2 as "signupMoveDown" }